<template>
  <div class="card" v-show="currentCardId == cardId">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>{{ heading }}</h2>
        <p>{{ description }}</p>
      </div>
      <div class="card-content">
        <div class="edit-form-list">
          <FormatDateActionFields v-model="dateValue" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import FormatDateActionFields from '@/components/format-edit/FormatDateActionFields.vue'
import { useTaishokutodokeFormatData } from '@/composables/format-edit/useTaishokutodokeFormatData'

type DateField = 'createDate' | 'retirementDate'

const props = defineProps<{
  currentCardId?: string
  cardId: string
  heading: string
  description: string
  field: DateField
}>()

const formatData = useTaishokutodokeFormatData()

const dateValue = computed({
  get() {
    return formatData[props.field]
  },
  set(next: Date | string | null) {
    formatData[props.field] = next as Date | null
  }
})
</script>
